import { render } from "./FormulaComponent.vue?vue&type=template&id=78f7ff87&scoped=true"
import script from "./FormulaComponent.vue?vue&type=script&lang=js"
export * from "./FormulaComponent.vue?vue&type=script&lang=js"

import "./FormulaComponent.vue?vue&type=style&index=0&id=78f7ff87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f7ff87"]])

export default __exports__